// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_e8t","cls2":"SimplePaperPodcast-cls2_iKg SimplePaperPodcast-cls1_e8t"};